export default __webpack_public_path__ + "static/media/gallery_3_300.b6bf13b8.webp";